import React from 'react';

import { Inline } from '@/ux-common/components/inline/inline';

/** Configuration for a legend item */
export interface LegendItem {
  /** The icon or visual indicator for this legend item */
  icon: React.ReactNode;
  /** The label text for this legend item */
  label: string;
}

interface SequencerLegendProps {
  /** Ordered legend items to display. */
  items: LegendItem[];
}

/**
 * SequencerLegend renders an ordered list of caller-defined legend items.
 *
 * @example
 * const items = [...standardLegendItems, activeStageLegendItem];
 * <SequencerLegend items={items} />
 *
 * @example
 * const items = [
 *   ...standardLegendItems,
 *   { icon: <TrimCircle />, label: 'Trim' },
 *   activeStageLegendItem,
 * ];
 * <SequencerLegend items={items} />
 */
export const SequencerLegend: React.FC<SequencerLegendProps> = ({ items }) => {
  return (
    <Inline className="inline-row-sm">
      <div className="text-secondary-foreground">Legend:</div>
      <Inline>
        {items.map((item) => (
          <Inline key={item.label} className="inline-row-xs text-secondary-foreground">
            {item.icon}
            <span>{item.label}</span>
          </Inline>
        ))}
      </Inline>
    </Inline>
  );
};
